import React from 'react';

import { Title, ButtonsGroup, Button, Input, Checkbox } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import { companyInfoSchema } from 'validation-schemas/direto';
import { LoanApplicationInput } from 'generated/graphql';
import { IStepInfo } from 'providers/profile.config';
import IconSecurity from 'assets/svg/icon-security';
import AtomicDropdown from 'components/AtomicDropdown';
import { getObjectAsList, formatMoneyWithoutDecimals } from 'utils/utils';
import { BorrowerRelationship } from 'enums/enums';
import UseTermsDialog from 'containers/direto/privacy-terms/dialogs/use-terms-dialog';
import PrivacyPolicyDialog from 'containers/direto/privacy-terms/dialogs/privacy-policy-dialog';
import AuthorizeInformationAccessDialog from 'containers/direto/privacy-terms/dialogs/authorize-information-access-dialog';

import './company-info.scss';
import { CONFIG } from 'constants/constants';

type CompanyInfoProps = {
    initialValue: LoanApplicationInput & {agreeTerms: boolean, authorizeInformationAccess: boolean};
    loading?: boolean;
    stepInfo: IStepInfo;
    screenProfile: 'default' | 'partners';
    onSubmit(LoanApplication: LoanApplicationInput): void;
    onBack(): void;
};

const CompanyInfoLayout: React.FC<CompanyInfoProps> = ({
    initialValue,
    onSubmit,
    onBack,
}) => (
    <div className="normal-screen company-info mb-5">
        <Form
            schema={companyInfoSchema}
            initialValues={initialValue}
            onSubmit={onSubmit}
            render={({ valid }) => (
                <>
                    <Title className="mb-5">
                        gostou? para analisar o pedido,
                        precisamos de alguns dados
                    </Title>

                    <div className="fields-inline mb-5 default-input-margin d-flex">
                        <IconSecurity className="mr-3 icon-min-width" />
                        <p className="body-1">
                            Seus dados estarão em segurança e serão usados unicamente para análise de crédito na biz.
                        </p>
                    </div>

                    <Field
                        component={Input}
                        placeholder="Nome Completo"
                        name="borrower.responsibleName"
                        maxLength={100}
                    />

                    <div className="fields-inline">

                        <Field
                            component={Input}
                            placeholder="E-mail"
                            name="borrower.email"
                            type="email"
                            maxLength={254}
                        />

                        <Field
                            component={Input}
                            placeholder="Celular com DDD"
                            name="borrower.phone"
                            mask="phone"
                            sendRawValue
                        />
                    </div>

                    <div className="fields-inline">
                        <Field
                            component={Input}
                            placeholder="CPF"
                            name="borrower.responsibleDocument"
                            mask="cpf"
                        />

                        <div className="field-group half default-input-margin" >
                            <label>
                                Qual a sua relação com a empresa?
                            </label>
                            <Field
                                component={AtomicDropdown}
                                options={getObjectAsList(BorrowerRelationship)}
                                name="borrower.relationship"
                            />
                        </div>
                    </div>

                    <div className="field-group mb-5" >
                        <Field
                            component={Input}
                            placeholder="Faturamento Mensal"
                            name="borrower.monthlyRevenue"
                            mask="money"
                            prefix="R$ "
                            sufix=" por mês"
                            info={`Mínimo de R$${formatMoneyWithoutDecimals(CONFIG.INFORMED_INCOME.MIN())} por mês. O faturamento deverá ser comprovado.`}
                            decimalScale={0}
                        />
                    </div>

                    <Field
                        component={Checkbox}
                        name="agreeTerms"
                        renderLabel={() => (
                            <>
                                concordo com os <UseTermsDialog /> e <PrivacyPolicyDialog />
                            </>
                        )}
                    />

                    <Field
                        component={Checkbox}
                        name="authorizeInformationAccess"
                        renderLabel={() => (
                            <>
                                autorizo o <br className="d-block d-sm-none" />
                                <AuthorizeInformationAccessDialog />
                            </>
                        )}
                    />


                    <ButtonsGroup className="mb-5">
                        <Button
                            label="voltar"
                            variant="secondary"
                            onClick={onBack}
                            data-category="Navegação Direto"
                            data-action="Clique Voltar"
                            data-label="Voltar /pedido/dados-pessoais"
                        />
                        <Button
                            label="continuar"
                            disabled={!valid}
                            type="submit"
                        />
                    </ButtonsGroup>
                </>
            )}
        />
    </div>
);

export default CompanyInfoLayout;
